import React, { Fragment, useState } from 'react';
import { Redirect } from 'react-router';
// import { useHistory } from 'react-router-dom';

import PageHelmet from 'components/common/Helmet';
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
import { Title } from 'components/title/Title';

// import Loader from 'component/Loader';

export const EmailVerification= (props) => {

	const { firebase, authUser } = props

	const [error, setError] = useState({})
	const [loading, setLoading] = useState(false)

	const handleSubmit = () => {
		setLoading(true)
		firebase
			.auth.onAuthStateChanged((user) => {
			user.sendEmailVerification()
				.then()
				.catch(err => setError(err));
		})
		setTimeout(() => {
			setLoading(false)
		}, 30000)
	}
	return !authUser.emailVerified ? (
		<Fragment>
			<PageHelmet pageTitle='Email Verification' />

			<Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

			<Title title='Email Verification' />

			<div className="contact-form--1 pt--50 pb--50">
				<div className="container">
					<div className="row row--35 align-items-center justify-content-center">
						<div className="col-lg-6">
							<div className="section-title text-left mb--50">
								<h2 className="title text-center">Activate Your Account</h2>
								<p className="text-center">We sent an email verification link to your email address. Please
									check your inbox for it and verify your email to access your Infinity Comics Profile.</p>
							</div>
							<button className="w-100 rn-button-style--2 btn-solid" onClick={handleSubmit} disabled={loading} name="registration">Resend Verification Email</button>
							{error && <p className="error">{error.message}</p>}
							<p className="text-center">
								If you didn't receive the verification link, click above to receive
								a new one.
							</p>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	) : <Redirect to='/account' />
}


